import client from './client';

export const listMeetings = () => client.get('/meetings').then((r) => r.data);
export const getMeeting = (id) => client.get(`/meetings/${id}`).then((r) => r.data);
export const createMeeting = (payload) => client.post('/meetings', payload).then((r) => r.data);
export const updateMeeting = (id, payload) => client.patch(`/meetings/${id}`, payload).then((r) => r.data);
export const confirmMeeting = (id) => client.post(`/meetings/${id}/confirm`).then((r) => r.data);
export const removeMeeting = (id) => client.delete(`/meetings/${id}`).then((r) => r.data);

export const meetingUsers = () => client.get('/meetings/users').then((r) => r.data);
export const listMeetingGroups = () => client.get('/meetings/groups').then((r) => r.data);
export const createMeetingGroup = (payload) => client.post('/meetings/groups', payload).then((r) => r.data);
export const removeMeetingGroup = (id) => client.delete(`/meetings/groups/${id}`).then((r) => r.data);
